<script>
	import _ from 'lodash'
	import FilterRow from './filter-row'
	import draggable from 'vuedraggable'

	export default {
		components: {
			'nk-filter-row': FilterRow,
			'draggable': draggable
		},
		props: {
			scheme: { type: Object, required: true },
			modelValue: { type: Object }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				localValue: {
					items: []
				},
				filterValues: [],
				counter: 1000,
				drag: false
			}
		},
		computed: {

		},
		watch: {
			modelValue: {
				immediate: true,
				deep: true,
				handler(val) {
					this.localValue = _.extend(this.localValue, val)
				}
			}
		},
		created() {

		},
		mounted() {
			this.addFilter()
		},
		methods: {
			addFilter() {
				let item = { group: this.localValue.id, id: this.counter++, key: null, type: null, filter: null, value: null, operator: 'and' }
				this.localValue.items.push(item)
			},
			findFilterValueIndex(item) {
				let index = this.localValue.items.findIndex(x => x.id === item.id)
				return index
			},
			filterRowValueChanged(val, deletedValue) {
				if (!val) {
					if (deletedValue) {
						let index = this.findFilterValueIndex(deletedValue)
						if (index > -1) {
							this.localValue.items.splice(index, 1)
						}
					}

					this.emitValue()
					return
				}

				let index = this.findFilterValueIndex(val)
				if (index > -1) {
					this.localValue.items.splice(index, 1, val)
				} else {
					this.localValue.items.push(val)
				}

				this.emitValue()
			},
			emitValue() {
				this.$emit('update:modelValue', this.localValue)
			},
			dragEnded() {
				this.drag = false

				this.$emit('update:modelValue', this.localValue)
			},
			onChangeItemInGroup(e) {
				if (e.added) {
					e.added.element.id = this.counter++
					e.added.element.group = this.localValue.id

					this.localValue.items.splice(e.added.newIndex, 0, e.added.element)
				} else if (e.removed) {
					this.localValue.items.splice(e.removed.oldIndex, 1)
				} else if (e.moved) {
					this.localValue.items.splice(e.moved.oldIndex, 1)
					this.localValue.items.splice(e.moved.newIndex, 0, e.moved.element)
				}
			}
		}
	}
</script>
<template>
	<ul class="filter-group">
		<draggable :value="localValue.items" group="filterGroupItems" @start="drag = true" @end="dragEnded" @change="onChangeItemInGroup" handle=".row-drag-col">
			<li v-for="(item, index) in localValue.items" :key="item.group.toString().padEnd(10, '.') + item.id">
				<div class="row no-gutters">
					<div class="d-none d-md-block col-md-auto row-drag-col">
						<a class="btn btn-sm btn-link">
							<icon icon="bars" />
						</a>
					</div>
					<div class="col-12 col-md">
						<nk-filter-row :scheme="scheme" :modelValue="item" :operatorEnabled="index > 0" :operatorVisible="true" :removeButtonVisible="true" @update:modelValue="filterRowValueChanged"></nk-filter-row>
					</div>
				</div>
			</li>
		</draggable>
		<li class="mt-1">
			<div class="row no-gutters">
				<div class="d-none d-md-block row-drag-col">
				</div>
				<div class="col-12 col-md-auto">
					<button class="btn btn-sm btn-block btn-info" type="button" @click.stop="addFilter">
						<icon icon="plus" />
					</button>
				</div>
			</div>
		</li>
	</ul>
</template>
<style>
	.row-drag-col {
		width: 30.5px;
	}

	.row-drag-col a {
		color: #b2b2b2 !important;
	}

	.filter-group {
		padding: 5px;
		list-style: none;
		position: relative;
	}

	.filter-group:before {
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		width: 5px;
		border: 1px solid #000000;
		border-left-width: 0;
	}

	.filter-group li {
		display: block;
		margin: 0 0 2px 0;
		padding: 0;
	}

	.filter-group li:first-child {
		margin-top: 0;
	}

	.filter-group li:last-child {
		margin-bottom: 0;
	}

	@media (min-width: 768px) {
		.plus-button-col {
			max-width: 70px;
		}
	}
</style>
